export default __webpack_public_path__ + "static/driveway-grating-b79f2b7dda2809dd7243bd333d8e85ad.webp";